<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новая акция</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" :loading="loading" :disabled="loading" @click="sendForm" class="v-btn--save">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Тайтл</v-subheader>
                    <v-text-field
                        ref="name"
                        v-model="sR.name"
                        v-validate="'required'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        single-line
                        text
                        solo
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Короткое описание</v-subheader>
                            <v-textarea
                                ref="sR_description"
                                v-model="sR.description"
                                v-validate="'required|max:140'"
                                data-vv-name="description"
                                :error-messages="errors.collect('description')"
                                text
                                solo
                                single-line
                                required
                                counter="140"/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="sR.status ? 'Включен' : 'Отключен'" v-model="sR.status" class="mt-0"/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <upload-img :image-width="1024" :image-height="1024" v-model="sR.img" :content-area="12"
                                        style="max-width: 253px;">
                                <div slot="activator">
                                    <v-avatar size="100%" v-ripple class="grey lighten-3" tile v-if="!sR.img">
                                        <img src="/static/img/media/image_blank.svg"
                                             alt="Нажмите чтобы добавить картинку для акции"/>
                                    </v-avatar>
                                    <v-avatar size="100%" v-ripple tile v-else>
                                        <img :src="sR.img.imageURL" alt="Изображение для акции"/>
                                    </v-avatar>
                                </div>
                            </upload-img>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Выберите тип</v-subheader>
                            <v-select
                                :items="types"
                                item-value="key"
                                item-text="value"
                                v-model="sR.stock_type"
                                text
                                solo/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Количество наградных бонусов</v-subheader>
                            <v-text-field
                                ref="stockValue"
                                mask="######"
                                v-model="sR.stock_value"
                                v-validate="'required|min_value:1'"
                                data-vv-name="stock_value"
                                :error-messages="errors.collect('stock_value')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Дата начало</v-subheader>
                            <v-menu
                                ref="startMenu"
                                v-if="!dateUnlim"
                                v-model="startMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                        v-model="sR.start_date"
                                        prepend-icon="event"
                                        readonly
                                        text
                                        solo/>
                                </template>
                                <v-date-picker
                                    ref="startPicker"
                                    locale="ru-ru"
                                    first-day-of-week="1"
                                    v-model="sR.start_date"
                                    :min="new Date().toISOString().substr(0, 10)"
                                    @change="saveStartMenu"/>
                            </v-menu>
                            <v-checkbox v-model="dateUnlim" label="Срок не установлен"/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Дата окончания</v-subheader>
                            <v-menu
                                ref="endMenu"
                                v-if="!dateUnlim"
                                v-model="endMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                        v-model="sR.end_date"
                                        prepend-icon="event"
                                        readonly
                                        text
                                        solo/>
                                </template>
                                <v-date-picker
                                    ref="endPicker"
                                    locale="ru-ru"
                                    first-day-of-week="1"
                                    v-model="sR.end_date"
                                    :min="new Date(tomorrow).toISOString().substr(0, 10)"
                                    @change="saveEndMenu"/>
                            </v-menu>
                            <v-checkbox disabled label="Срок не установлен" v-model="dateUnlimCopy" v-show="dateUnlim"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Основной Текст</v-subheader>
                    <wysiwyg v-model="sR.text"/>
                </v-flex>
            </v-form>
            <v-dialog v-model="showDialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение</h4>
                    </v-card-title>
                    <v-card-text>
                        При создании акции, у всех акций данного типа статус поменятся на неактивный <br/> Вы уверены
                        что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitCreate">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="createStock">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="showDialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
    import UploadImg from '../../../../components/Media/Upload'
    import StockReg from '../../../../api/stockregister'

    export default {
        name: 'addStockRegister',
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            startMenu: false,
            endMenu: false,
            dateUnlim: false,
            dateUnlimCopy: true,
            tomorrow: new Date(),
            types: [
                {
                    key: 0,
                    value: 'Любая платформа'
                },
                {
                    key: 1,
                    value: 'Моб.приложение'
                },
                {
                    key: 2,
                    value: 'Моб.приложение - iOs'
                },
                {
                    key: 3,
                    value: 'Моб.приложение - Android'
                },
                {
                    key: 4,
                    value: 'Сайт'
                },
            ],
            sR: {
                name: '',
                img: '',
                status: true,
                description: '',
                text: '',
                stock_type: 1,
                stock_value: null,
                start_date: null,
                end_date: null
            },
            showDialog: false,
            waitCreate: false,
            dictionary: {
                custom: {
                    name: {
                        required: 'Название не введено'
                    },
                    description: {
                        required: 'Короткое описание не введено'
                    },
                    stock_value: {
                        min_value: 'Бонус не может быть равен нулью'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
        },
        methods: {
            saveStartMenu (date) {
                this.sR.end_date = null
                this.tomorrow = new Date(date)
                this.tomorrow.setDate(this.tomorrow.getDate() + 1)
                this.$refs.startMenu.save(date)
            },
            saveEndMenu (date) {
                if (!this.sR.start_date) {
                    this.sR.end_date = null

                    return
                }

                this.$refs.endMenu.save(date)
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        if (this.dateUnlim) {
                            this.sR.start_date = null
                            this.sR.end_date = null
                        }

                        if (!this.dateUnlim && !this.sR.start_date && !this.sR.end_date) {
                            this.$store.commit('showSnackbar', { text: 'Выберите дату' })

                            return
                        }

                        this.loading = true
                        this.showDialog = true
                    })
                    .catch(error => new Error(error))
            },
            createStock () {
                this.waitCreate = true

                StockReg
                    .create(this.sR)
                    .then(response => {
                        this.$store.commit('storeStockRegister', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Успех! Акция создано',
                            color: 'success'
                        })
                        this.$router.push({ name: 'stockRegister' })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                    .finally(() => this.loading = false)
            }
        },
        watch: {
            startMenu (val) {
                // val && setTimeout(() => (this.$refs.start_picker.activePicker = 'YEAR'))
            },
            endMenu (val) {
                // val && setTimeout(() => (this.$refs.end_picker.activePicker = 'YEAR'))
            }
        },
    }
</script>
